module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_11_59_986Z.51913224.png";